/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]{width:100%;height:100%}.axis-template-text[_ngcontent-%COMP%]:not([title=\"No Data\"]){font-weight:400;cursor:pointer}.axis-template-text[_ngcontent-%COMP%]:not([title=\"No Data\"]):hover{font-weight:600;text-decoration:underline}"];
export { styles as styles };
